import api from '.';

export interface UpdatePassword {
  oldPassword: string;
  newPassword: string;
}

export async function updatePasswordExternalUser(
  updatePassword: UpdatePassword
) {
  const { data } = await api.put(
    `${process.env.REACT_APP_PROJECT_REGISTER_URL}/external-users/update-password`,
    updatePassword
  );

  return data;
}
